import { AcessTypePropertyInteractor, AcessTypePropertyRequest, AcessTypePropertyStructRequest } from "../../Coordinator/AcessTypeProperty/AcessTypePropertyInteractor";

export class AcessTypePropertyViewModel {
    private interactor: AcessTypePropertyInteractor;

	constructor() {
		this.interactor = new AcessTypePropertyInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new AcessTypePropertyRequest(
            obj["sgepproptpacesso"] ? parseInt(obj["sgepproptpacesso"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new AcessTypePropertyStructRequest(
            obj["sgepproptpacesso"] ? parseInt(obj["sgepproptpacesso"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}